import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import BCXInfoSection from '@/components/molecules/BCXInfoSection.vue';
import ProfileEditActionButtons from '@/views/profile/components/ProfileEditActionButtons.vue';
import UploadableItem from '@/components/molecules/UploadableItem.vue';
import { deleteExperiences, updateExperiences } from '@/services/Profile/Api';
import useProfileState from '@/state/profile/profileState';
import { ProfileMaxChars } from '@/models/Profile';
import sanitizeText from '@/views/profile/utils/sanitizeText';
import ProfileRichTextEditor from '@/views/profile/components/ProfileRichTextEditor.vue';
import EditIcon from '@/components/molecules/EditIcon.vue';
import buildExperiencesSavePayload from '@/views/profile/utils/buildExperiencesSavePayload';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileProjectsEditor',
  setup(__props) {

const { profile, patchSavedProfile } = useProfileState();
const text = ref('');
const title = ref('');
const fileName = ref('');
const fileContents = ref('');
const initialTitle = ref('');
const canSend = ref(false);
const documentRemoved = ref(false);

watch(
  profile,
  (profile) => {
    const { experiencesDocumentLabel = '', experiencesText = '' } = profile?.experiences ?? {};
    text.value = sanitizeText(experiencesText);
    title.value = experiencesDocumentLabel;
    initialTitle.value = title.value;
    documentRemoved.value = false;
  },
  { immediate: true }
);

watch([fileName, fileContents], ([nextFileName, nextFileContents]) => {
  if (nextFileName || nextFileContents) {
    documentRemoved.value = false;
  }
});

const save = async () => {
  const payload = buildExperiencesSavePayload({
    documentRemoved: documentRemoved.value,
    text: text.value,
    title: title.value,
    fileName: fileName.value,
    fileContents: fileContents.value,
    existingDocument: profile.value?.experiences?.experiencesDocument ?? null,
    existingDocumentLabel: profile.value?.experiences?.experiencesDocumentLabel ?? '',
  });

  if (documentRemoved.value) {
    await deleteExperiences();
  }

  const responseData = await updateExperiences(payload);
  patchSavedProfile({
    experiences: {
      experiencesText: responseData.experiencesText,
      experiencesDocumentLabel: payload.experiencesDocumentLabel,
      experiencesDocument: payload.experiencesDocument ?? null,
    },
  });
  text.value = responseData.experiencesText;
  // editor.value.invoke('setHTML', responseData.experiencesText);
};

const remove = () => {
  documentRemoved.value = true;
  fileContents.value = '';
  fileName.value = '';
  title.value = '';
  initialTitle.value = '';
};

return { __sfc: true,profile, patchSavedProfile, text, title, fileName, fileContents, initialTitle, canSend, documentRemoved, save, remove, BCXInfoSection, ProfileEditActionButtons, UploadableItem, ProfileMaxChars, ProfileRichTextEditor, EditIcon }
}

})